import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-left.double"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 7.5L6 12L10.5 16.5M17 7.5L12.5 12L17 16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronLeftDouble = Vue.extend<IconProps>({
  name: 'ChevronLeftDoubleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chevron-left-double',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChevronLeftDouble;
